import * as React from "react";
import { forwardRef } from "react";
const SvgStopCallRecording = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 3, rx: 2, ry: 2, width: 18, height: 18, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgStopCallRecording);
export default ForwardRef;
